var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9441 0.931126C19.6045 0.931126 25 6.3395 25 12.9999C25 19.6733 19.6045 25.0689 12.9441 25.0689C6.27072 25.0689 0.875244 19.6733 0.875244 12.9999C0.875244 6.3395 6.27072 0.931126 12.9441 0.931126Z",
    fill: "#FF2682"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8386 10.8016C12.2814 7.86712 15.8226 6.10891 17.9027 8.23863C17.9027 8.23863 18.8313 7.97855 19.6609 7.4586C19.6609 7.4586 19.3637 8.4615 18.3485 9.093C18.3485 9.093 19.4752 8.94435 19.9581 8.64716C19.9581 8.64716 19.4752 9.65017 18.5713 10.0216C19.0667 16.7696 11.7985 20.8555 5.91724 17.5125C5.91724 17.5125 8.81452 17.661 10.0528 16.2372C10.0528 16.2372 8.25735 16.3982 7.36588 14.2313C7.36588 14.2313 8.03448 14.4914 8.70309 14.1571C8.70309 14.1571 6.62295 13.8227 6.4373 11.3217C6.4373 11.3217 7.1059 11.8541 7.84883 11.6683C7.84883 11.6683 5.54582 10.2816 6.84582 7.7929C6.84582 7.7929 9.30984 10.9131 12.8386 10.8016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter_icon.c89468ac2799bd75786f423870d41084.svg";
export { ForwardRef as ReactComponent };